import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import data from '../../data/team';

function Team() {
  const [selectedMember, setSelectedMember] = useState(null);

  // Funkce pro otevření modalu
  const openModal = (member, type) => {
    setSelectedMember({ ...member, contactType: type });
  };

  // Scroll Lock: Když je modal otevřený, zamezíme scrollování na pozadí
  useEffect(() => {
    if (selectedMember) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    // Cleanup při zavření komponenty
    return () => {
      document.body.style.overflow = '';
    };
  }, [selectedMember]);

  return (
    <section className="team section-padding pt-0 relative">
      <div className="container">
        <div className="sec-head mb-80">
          <div className="d-flex align-items-center">
            <div>
              <span className="sub-title main-color mb-5">Our Team</span>
              <h3 className="fw-600 fz-50 text-u d-rotate wow">
                <span className="rotate-text">
                  Meet our <span className="fw-200">legends.</span>
                </span>
              </h3>
            </div>
            {/* <div className="ml-auto vi-more">
              <a href="/page-team" className="butn butn-sm butn-bord radius-30">
                <span>Join to us</span>
              </a>
              <span className="icon ti-arrow-top-right"></span>
            </div> */}
          </div>
        </div>
        <div className="row">
          {data.map((item, i) => (
            <div key={i} className="col-lg-4">
              <div className="item md-mb50">
                <div className="img">
                  <img src={item.img} alt="" />
                  <div className="info">
                    <span className="fz-12">{item.subName}</span>
                    <h6 className="fz-18">{item.name}</h6>
                  </div>
                </div>
                <div className="social">
                  <div className="links">
                    <a href={item.linkedin} target='_blank' rel="noreferrer">
                      <i className="fab fa-linkedin"></i>
                    </a>
                    <span onClick={() => openModal(item, 'email')} className="pointer cursor-pointer">
                      <i className="fas fa-at"></i>
                    </span>
                    <span onClick={() => openModal(item, 'phone')} className="pointer cursor-pointer">
                      <i className="fas fa-phone"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* RENDER MODALU PŘES PORTAL */}
      {selectedMember && createPortal(
        <div className="custom-modal-overlay" onClick={() => setSelectedMember(null)}>
          <div className="custom-modal-content" onClick={e => e.stopPropagation()}>
            <h4>{selectedMember.name}</h4>
            <h6 className='mb-15'>
              {selectedMember.contactType === 'email' ? 'Mail me on:' : 'Call me on:'}
            </h6>
            
            <div className="contact-value">
              {/* Přidány klikací linky pro lepší UX na mobilu */}
              {selectedMember.contactType === 'email' ? (
                <a href={`mailto:${selectedMember.email}`} style={{ color: 'inherit' }}>
                  {selectedMember.email}
                </a>
              ) : (
                <a href={`tel:${selectedMember.mobile}`} style={{ color: 'inherit' }}>
                  {selectedMember.mobile}
                </a>
              )}
            </div>
            
            <button className='close-btn' onClick={() => setSelectedMember(null)}>Close</button>
          </div>
        </div>,
        document.body // Teleportuje modal ven z GSAP wrapperu
      )}
    </section>
  );
}

export default Team;